import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import { useMemo } from "react";
import { default as ReactSelect, default as Select } from "react-select";
import CloseIcon from "../../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../../components/CustomButtonV2/CustomButtonV2";
import HeaderCadastro from "../../../../../components/HeaderCadastro/HeaderCadastro";
import LoadingBar from "../../../../../components/LoadingBar/LoadingBar";
import NewIcon from "../../../../../components/NewIcon/NewIcon";
import SelectEmbarqueV2 from "../../../../../components/SelectEmbarqueV2/SelectEmbarqueV2";
import { useTabela } from "../../../../../contexts/Tabela";
import { useToast } from "../../../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../../../core/components/MotionContainer.tsx";
import { estiloBase, estiloCidadeEstado, estiloErro, labelVeiculo, opcoesSelect, opcoesVeiculo } from "./VeiculoHelpers.tsx";

type CidadeEstadoOption = {
    idCidadeEstado: number;
    opcao: string;
    valor: string;
};

interface VeiculoCadastroProps {
    desabilitar?: boolean;
    botaoFechar?: boolean;
    botaoCadastrar?: boolean;
    botaoVoltar?: boolean;
    editando: boolean;
    setValues: React.Dispatch<React.SetStateAction<any>>;
    removerErrosVazios: (obj: any) => void;
    setValuesSelect: React.Dispatch<React.SetStateAction<any>>;
    setTelaCadastro: React.Dispatch<React.SetStateAction<boolean>>;
    setEditando: React.Dispatch<React.SetStateAction<boolean>>;
    validator: any;
    setValidator: React.Dispatch<React.SetStateAction<any>>;
    loadingSelectCaminhao: boolean;
    verificadorExistenciaVeiculo: (placa: string) => void;
    setErroPlacaCavalo: React.Dispatch<React.SetStateAction<boolean>>;
    setDisable: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCadastroCaminhao: React.Dispatch<React.SetStateAction<boolean>>;
    clearPlacaCavalo: boolean;
    setIdAtual: React.Dispatch<React.SetStateAction<number | null>>;
    valuesSelect: any;
    placaValida: boolean;
    erroPlacaCavalo: boolean;
    listaCaminhoes: any[];
    loadingSelectCarreta: boolean;
    listaCarretas: any[];
    loadingSelectProprietario: boolean;
    listaProprietario: any[];
    loadingSelectMotorista: boolean;
    listaMotoristas: any[];
    loadingSelectCarroceria: boolean;
    listaCarrocerias: any[];
    loadingSelectTipoVeiculo: boolean;
    erroProprietario: boolean;
    erroMotorista: boolean;
    clearPlacaCarreta: boolean;
    clearPlacaCarreta2: boolean;
    clearProprietario: boolean;
    clearMotorista: boolean;
    clearMotorista2: boolean;
    clearTipoCarroceria: boolean;
    erroTipoVeiculoApiSul: boolean;
    erroTipoCarroceria: boolean;
    erroTipoVeiculo: boolean;
    setOpenCadastroCarreta: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCadastroProprietario: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCadastro: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCadastroCarroceria: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenCadastroTipoVeiculo: React.Dispatch<React.SetStateAction<boolean>>;
    setErroTipoVeiculoApiSul: React.Dispatch<React.SetStateAction<boolean>>;
    setErroTipoCarroceria: React.Dispatch<React.SetStateAction<boolean>>;
    setErroTipoVeiculo: React.Dispatch<React.SetStateAction<boolean>>;
    elegivelValido: boolean;
    erroElegivelBrf: boolean;
    setElegivelValido: React.Dispatch<React.SetStateAction<boolean>>;
    setErroElegivelBrf: React.Dispatch<React.SetStateAction<boolean>>;
    opcoesCidadeEstado: CidadeEstadoOption[];
    labelCidadeEstado: (data: CidadeEstadoOption) => JSX.Element;
    cadastrar: () => void;
    validarCamposVazios: () => void;
    setErroProprietario: React.Dispatch<React.SetStateAction<boolean>>;
    setErroMotorista: React.Dispatch<React.SetStateAction<boolean>>;
    clearTipoVeiculo: () => void;
    listaTipoVeiculos: any[];
    classeCss: string;
    values: any;
    editar: () => void;
}

function VeiculoCadastro({
    desabilitar,
    botaoFechar,
    botaoCadastrar,
    botaoVoltar,
    editando,
    values,
    setValues,
    removerErrosVazios,
    setValuesSelect,
    setTelaCadastro,
    setEditando,
    validator,
    setValidator,
    loadingSelectCaminhao,
    verificadorExistenciaVeiculo,
    setErroPlacaCavalo,
    setDisable,
    setOpenCadastroCaminhao,
    clearPlacaCavalo,
    setIdAtual,
    valuesSelect,
    placaValida,
    erroPlacaCavalo,
    listaCaminhoes,
    loadingSelectCarreta,
    setOpenCadastroCarreta,
    clearPlacaCarreta,
    listaCarretas,
    clearPlacaCarreta2,
    loadingSelectProprietario,
    setErroProprietario,
    setOpenCadastroProprietario,
    clearProprietario,
    listaProprietario,
    erroProprietario,
    setErroMotorista,
    setOpenCadastro,
    clearMotorista,
    listaMotoristas,
    erroMotorista,
    loadingSelectMotorista,
    clearMotorista2,
    erroTipoVeiculoApiSul,
    setErroTipoVeiculoApiSul,
    loadingSelectCarroceria,
    setErroTipoCarroceria,
    setOpenCadastroCarroceria,
    clearTipoCarroceria,
    listaCarrocerias,
    erroTipoCarroceria,
    loadingSelectTipoVeiculo,
    setErroTipoVeiculo,
    setOpenCadastroTipoVeiculo,
    clearTipoVeiculo,
    listaTipoVeiculos,
    erroTipoVeiculo,
    elegivelValido,
    erroElegivelBrf,
    setElegivelValido,
    setErroElegivelBrf,
    opcoesCidadeEstado,
    labelCidadeEstado,
    cadastrar,
    validarCamposVazios,
    classeCss,
    editar,
}: VeiculoCadastroProps) {
    const { showToast } = useToast();
    const { setTabelaRedux } = useTabela();

    const customStylesErro = useMemo(() => estiloErro({ classeCss }), [classeCss]);

    const estiloVeiculo = useMemo(() => estiloBase({ classeCss }), [classeCss]);

    const cidadeEstadoStyle = useMemo(() => estiloCidadeEstado({ classeCss }), [classeCss]);

    return (
        <MotionContainer scroll animationKey="VeiculoCadastroScreen">
            <div className="content-container-scrollable">
                {!desabilitar && (
                    <div className="texto-cadastro-container">
                        {botaoFechar && (
                            <div style={{ width: 29, height: 29 }} />
                        )}
                        <div className="texto-cadastro">
                            <p className="indicador-emb">{"Dados de Veiculo / "}</p>
                            {editando ? (
                                <p className="indicador-emb">{"Detalhes de Veiculo"}</p>
                            ) : (
                                <p className="indicador-emb">{"Cadastro de Veiculo"}</p>
                            )}
                            <HeaderCadastro texto="" />
                        </div>
                        {botaoFechar && (
                            <div className="close-btn">
                                <CloseIcon
                                    onClick={() => {
                                        setValues({});
                                        removerErrosVazios({});
                                        setValuesSelect({});
                                        setTelaCadastro(false);
                                        setEditando(false);
                                        setTabelaRedux({});
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}
                <div className="flex-column">
                    <div className="rota-div-2">
                        {loadingSelectCaminhao ? (
                            <LoadingBar />
                        ) : (
                            <div
                                className={
                                    validator.placaCavalo === "false"
                                        ? "coluna-emb"
                                        : "coluna-emb-erro"
                                }
                            >
                                <div>
                                    <p className="input-label-emb">
                                        Placa Cavalo:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                placaCavalo: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                CaminhaoId: e.id,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                placaCavalo: e.value,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                placaCavalo: "true",
                                            }));
                                            verificadorExistenciaVeiculo(e.value);
                                            setErroPlacaCavalo(false);
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroCaminhao(true);
                                        }}
                                        clearSelection={clearPlacaCavalo}
                                        onInfoIconClick={setIdAtual}
                                        id="idCaminhao"
                                        value={valuesSelect.placaCavalo}
                                        titulo="Placa Cavalo"
                                        erro={!placaValida || erroPlacaCavalo}
                                        dadosSelect={listaCaminhoes}
                                        referenciaId="placa"
                                        referenciaItem="placa"
                                        disabled={desabilitar || editando}
                                    />
                                    {!placaValida && (
                                        <div className="error-text">Placa já cadastrada</div>
                                    )}
                                    {erroPlacaCavalo && (
                                        <div className="error-text">Campo Obrigatório</div>
                                    )}
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroCaminhao(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                        {loadingSelectCarreta ? (
                            <LoadingBar />
                        ) : (
                            <div className="coluna-emb">
                                <div>
                                    <p className="input-label-emb">
                                        Placa Carreta:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                placaCarreta: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                placaCarreta: e.value,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                carretaId: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                placaCarreta: "true",
                                            }));
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroCarreta(true);
                                        }}
                                        clearSelection={clearPlacaCarreta}
                                        onInfoIconClick={setIdAtual}
                                        id="idCarreta"
                                        value={valuesSelect.placaCarreta}
                                        titulo="Placa Carreta"
                                        dadosSelect={listaCarretas}
                                        referenciaId="placa"
                                        referenciaItem="placa"
                                        disabled={desabilitar}
                                    />
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroCarreta(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="rota-div-2">
                        {loadingSelectCarreta ? (
                            <LoadingBar />
                        ) : (
                            <div className="coluna-emb">
                                <div>
                                    <p className="input-label-emb">
                                        Placa Carreta 2:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                placaCarreta2: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                placaCarreta2: e.value,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                carreta2Id: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                placaCarreta2: "true",
                                            }));
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroCarreta(true);
                                        }}
                                        clearSelection={clearPlacaCarreta2}
                                        onInfoIconClick={setIdAtual}
                                        id="idCarreta"
                                        value={valuesSelect.placaCarreta2}
                                        titulo="Placa Carreta 2"
                                        dadosSelect={listaCarretas}
                                        referenciaId="placa"
                                        referenciaItem="placa"
                                        disabled={desabilitar}
                                    />
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroCarreta(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                        {loadingSelectProprietario ? (
                            <LoadingBar />
                        ) : (
                            <div
                                className={
                                    validator.proprietario === "false"
                                        ? "coluna-emb"
                                        : "coluna-emb-erro"
                                }
                            >
                                <div>
                                    <p className="input-label-emb">
                                        Proprietário:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                proprietario: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                proprietario: e.value,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                proprietarioId: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                proprietario: "true",
                                            }));
                                            setErroProprietario(false);
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroProprietario(true);
                                        }}
                                        clearSelection={clearProprietario}
                                        onInfoIconClick={setIdAtual}
                                        id="idProprietario"
                                        value={valuesSelect.proprietario}
                                        titulo="Proprietário"
                                        dadosSelect={listaProprietario}
                                        referenciaId="nome"
                                        referenciaItem="nome"
                                        disabled={desabilitar}
                                        erro={erroProprietario}
                                    />
                                    {erroProprietario && (
                                        <div className="error-text">Campo Obrigatório</div>
                                    )}
                                </div>

                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroProprietario(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="rota-div-2">
                        {loadingSelectMotorista ? (
                            <LoadingBar />
                        ) : (
                            <div
                                className={
                                    validator.motorista === "false"
                                        ? "coluna-emb"
                                        : "coluna-emb-erro"
                                }
                            >
                                <div>
                                    <p className="input-label-emb">
                                        Motorista:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                motorista: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                motorista: e.value,
                                                motoristaId: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                motorista: "true",
                                            }));
                                            setErroMotorista(false);
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastro(true);
                                        }}
                                        clearSelection={clearMotorista}
                                        onInfoIconClick={setIdAtual}
                                        id="idMotorista"
                                        value={valuesSelect.motorista}
                                        titulo="Motorista"
                                        dadosSelect={listaMotoristas}
                                        referenciaId="nome"
                                        referenciaItem="nome"
                                        disabled={desabilitar}
                                        erro={erroMotorista}
                                    />
                                    {erroMotorista && (
                                        <div className="error-text">Campo Obrigatório</div>
                                    )}
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastro(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                        {loadingSelectMotorista ? (
                            <LoadingBar />
                        ) : (
                            <div className="coluna-emb">
                                <div>
                                    <p className="input-label-emb">
                                        Motorista 2:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={250}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                motorista2: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                motorista2Id: e.id,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                motorista2: e.value,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                motorista: "true",
                                            }));
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastro(true);
                                        }}
                                        clearSelection={clearMotorista2}
                                        onInfoIconClick={setIdAtual}
                                        id="idMotorista"
                                        value={valuesSelect.motorista2}
                                        titulo="Motorista 2"
                                        dadosSelect={listaMotoristas}
                                        referenciaId="nome"
                                        referenciaItem="nome"
                                        disabled={desabilitar}
                                    />
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastro(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="rota-div-2">
                        <div className="coluna-emb">
                            <div>
                                <p className="input-label-emb">
                                    Tipo Veículo APISUL:
                                </p>
                                <FormControl
                                    sx={{
                                        width: 265,
                                        borderRadius: "7px",
                                        border: erroTipoVeiculoApiSul
                                            ? "1px solid #DC2D2D"
                                            : estiloVeiculo,
                                    }}
                                >
                                    <Select
                                        value={valuesSelect.tipoVeiculo}
                                        options={opcoesVeiculo}
                                        formatOptionLabel={labelVeiculo}
                                        styles={estiloVeiculo}
                                        placeholder="Selecione"
                                        noOptionsMessage={() => "Não há mais opções"}
                                        onChange={(selectedOption) => {
                                            if (selectedOption) {
                                                setValues((current: any) => ({
                                                    ...current,
                                                    tipoVeiculo: selectedOption.valor,
                                                }));
                                                setValuesSelect((current: any) => ({
                                                    ...current,
                                                    tipoVeiculo: selectedOption,
                                                }));
                                                setValidator((current: any) => ({
                                                    ...current,
                                                    tipoVeiculo: "true",
                                                }));
                                                setErroTipoVeiculoApiSul(false);
                                            }
                                        }}
                                    />
                                </FormControl>
                                {erroTipoVeiculoApiSul && (
                                    <div className="error-text">Obrigatório!</div>
                                )}
                            </div>
                        </div>
                        {loadingSelectCarroceria ? (
                            <LoadingBar />
                        ) : (
                            <div
                                className={
                                    validator.tipoCarroceria === "false"
                                        ? "coluna-emb"
                                        : "coluna-emb-erro"
                                }
                            >
                                <div>
                                    <p className="input-label-emb">
                                        Tipo Carroceria:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={275}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                tipoCarroceria: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                tipoCarroceria: e.value,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                tipoCarroceriaId: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                tipoCarroceria: "true",
                                            }));
                                            setErroTipoCarroceria(false);
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroCarroceria(true);
                                        }}
                                        clearSelection={clearTipoCarroceria}
                                        onInfoIconClick={setIdAtual}
                                        id="id"
                                        value={valuesSelect.tipoCarroceria}
                                        titulo="Placa Carreta"
                                        dadosSelect={listaCarrocerias}
                                        referenciaId="nome"
                                        referenciaItem="nome"
                                        disabled={desabilitar}
                                        erro={erroTipoCarroceria}
                                    />
                                    {erroTipoCarroceria && (
                                        <div className="error-text">Campo Obrigatório</div>
                                    )}
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroCarroceria(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="rota-div-2">
                        {loadingSelectTipoVeiculo ? (
                            <LoadingBar />
                        ) : (
                            <div
                                className={
                                    validator.tipoVeiculoConjuntos === "false"
                                        ? "coluna-emb"
                                        : "coluna-emb-erro"
                                }
                            >
                                <div>
                                    <p className="input-label-emb">
                                        Tipo Veículo:
                                    </p>
                                    <SelectEmbarqueV2
                                        classeCss={230}
                                        onChange={(e: any) => {
                                            setValuesSelect((current: any) => ({
                                                ...current,
                                                tipoVeiculoConjuntos: e,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                tipoVeiculoConjuntos: e.value,
                                            }));
                                            setValues((current: any) => ({
                                                ...current,
                                                tipoVeiculoId: e.id,
                                            }));
                                            setValidator((current: any) => ({
                                                ...current,
                                                tipoVeiculoConjuntos: "true",
                                            }));
                                            setErroTipoVeiculo(false);
                                        }}
                                        onClick={(e: any) => {
                                            e.stopPropagation();
                                            setDisable(true);
                                            setOpenCadastroTipoVeiculo(true);
                                        }}
                                        clearSelection={clearTipoVeiculo}
                                        onInfoIconClick={setIdAtual}
                                        id="id"
                                        value={valuesSelect.tipoVeiculoConjuntos}
                                        titulo="Placa Carreta"
                                        dadosSelect={listaTipoVeiculos}
                                        referenciaId="nome"
                                        referenciaItem="nome"
                                        disabled={desabilitar}
                                        erro={erroTipoVeiculo}
                                    />
                                    {erroTipoVeiculo && (
                                        <div className="error-text">Campo Obrigatório</div>
                                    )}
                                </div>
                                <NewIcon
                                    onClick={(e: any) => {
                                        setOpenCadastroTipoVeiculo(true);
                                        setIdAtual(null);
                                        setDisable(false);
                                    }}
                                />
                            </div>
                        )}
                        <div
                            className={
                                elegivelValido ? "coluna-emb" : "coluna-emb-erro"
                            }
                        >
                            <div>
                                <p className="input-label-emb">
                                    Elegível BRF:
                                </p>
                                <FormControl sx={{ width: 160 }}>
                                    <Select
                                        value={valuesSelect.elegivelBrf}
                                        options={opcoesSelect}
                                        formatOptionLabel={labelVeiculo}
                                        styles={
                                            !erroElegivelBrf ? estiloVeiculo : customStylesErro
                                        }
                                        placeholder="Selecione"
                                        noOptionsMessage={() => "Não há mais opções"}
                                        onChange={(selectedOption) => {
                                            if (selectedOption) {
                                                setElegivelValido(true);
                                                setValues((current: any) => ({
                                                    ...current,
                                                    elegivelBrf: selectedOption.valor,
                                                }));
                                                setValuesSelect((current: any) => ({
                                                    ...current,
                                                    elegivelBrf: selectedOption,
                                                }));
                                                setValidator((current: any) => ({
                                                    ...current,
                                                    elegivelBrf: "true",
                                                }));
                                                setErroElegivelBrf(false);
                                            }
                                        }}
                                    />
                                </FormControl>
                                {erroElegivelBrf && (
                                    <div className="error-text">Obrigatório!</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="rota-div-2">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.ativoDiaria}
                                    onChange={(e: any) => {
                                        if (e.target.checked === true) {
                                            setValues((current: any) => ({
                                                ...current,
                                                ativoDiaria: true,
                                            }));
                                        } else {
                                            setValues((current: any) => ({
                                                ...current,
                                                ativoDiaria: false,
                                            }));
                                        }
                                    }}
                                />
                            }
                            label={"Ativo Diária"}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.agregado}
                                    onChange={(e: any) => {
                                        if (e.target.checked === true) {
                                            setValues((current: any) => ({
                                                ...current,
                                                agregado: true,
                                            }));
                                        } else {
                                            setValues((current: any) => ({
                                                ...current,
                                                agregado: false,
                                            }));
                                        }
                                    }}
                                />
                            }
                            label="Agregado"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.telemetria}
                                    onChange={(e: any) => {
                                        if (e.target.checked === true) {
                                            setValues((current: any) => ({
                                                ...current,
                                                telemetria: true,
                                            }));
                                        } else {
                                            setValues((current: any) => ({
                                                ...current,
                                                telemetria: false,
                                            }));
                                        }
                                    }}
                                />
                            }
                            label="Telemetria"
                        />
                    </div>
                    <div className="rota-div-2">
                        <div className="coluna-emb">
                            <div>
                                <p className="input-label-emb">
                                    Cidade/UF:
                                </p>
                                <FormControl sx={{ width: 220 }}>
                                    <ReactSelect
                                        value={valuesSelect.cidadeEstadoId}
                                        isDisabled={desabilitar}
                                        options={opcoesCidadeEstado}
                                        formatOptionLabel={labelCidadeEstado}
                                        styles={cidadeEstadoStyle}
                                        placeholder="Selecione"
                                        noOptionsMessage={() => "Não há mais opções"}
                                        onChange={(selectedOption) => {
                                            if (selectedOption) {
                                                setValues((current: any) => ({
                                                    ...current,
                                                    cidadeEstadoId: selectedOption.idCidadeEstado,
                                                }));
                                                setValuesSelect((current: any) => ({
                                                    ...current,
                                                    cidadeEstadoId: selectedOption,
                                                }));
                                                setValidator((current: any) => ({
                                                    ...current,
                                                    cidadeEstadoId: "true",
                                                }));
                                            }
                                        }}
                                    />
                                </FormControl>
                            </div>
                        </div>
                        <div className="coluna-emb">
                            <div>
                                <p className="input-label-emb">
                                    Data Última Localização:
                                </p>
                                <input
                                    type="date"
                                    className="input-emb"
                                    style={{ width: "190px" }}
                                    onChange={(e: any) => {
                                        setValues((current: any) => ({
                                            ...current,
                                            dataAtualizacaoLocalizacao: e.target.value,
                                        }));
                                        setValidator((current: any) => ({
                                            ...current,
                                            dataAtualizacaoLocalizacao: "true",
                                        }));
                                    }}
                                    value={values.dataAtualizacaoLocalizacao}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-container">
                {editando ? (
                    <CustomButtonV2
                        classCss="custom-button-cadastrar"
                        classText="button-texto-cadastrar"
                        icone="iconeSave"
                        titulo="Salvar"
                        cor="#0946B8"
                        valor={values}
                        onClick={() => {
                            editar();
                        }}
                    />
                ) : (
                    <>
                        {!desabilitar &&
                            (botaoCadastrar ? (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        if (
                                            values.placaCavalo !== "" &&
                                            values.proprietario !== "" &&
                                            values.motorista !== "" &&
                                            values.tipoCarroceria !== "" &&
                                            values.tipoVeiculoConjuntos !== "" &&
                                            values.elegivelBrf !== "" &&
                                            validator.placaCavalo === "true" &&
                                            validator.proprietario === "true" &&
                                            validator.motorista === "true" &&
                                            validator.tipoCarroceria === "true" &&
                                            validator.tipoVeiculoConjuntos === "true" &&
                                            validator.elegivelBrf === "true"
                                        ) {
                                            cadastrar();
                                        } else {
                                            validarCamposVazios();
                                            showToast("Há campos sem preencher!", "error");
                                        }
                                    }}
                                />
                            ) : (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        if (
                                            values.placaCavalo !== "" &&
                                            values.proprietario !== "" &&
                                            values.motorista !== "" &&
                                            values.tipoCarroceria !== "" &&
                                            values.tipoVeiculoConjuntos !== "" &&
                                            values.elegivelBrf !== "" &&
                                            validator.placaCavalo === "true" &&
                                            validator.proprietario === "true" &&
                                            validator.motorista === "true" &&
                                            validator.tipoCarroceria === "true" &&
                                            validator.tipoVeiculoConjuntos === "true" &&
                                            validator.elegivelBrf === "true"
                                        ) {
                                            cadastrar();
                                        } else {
                                            validarCamposVazios();
                                            showToast("Há campos sem preencher!", "error");
                                        }
                                    }}
                                />
                            ))}
                    </>
                )}
                {!botaoVoltar && (
                    <CustomButtonV2
                        classCss="custom-button-cancelar"
                        classText="button-texto-cancelar"
                        titulo="Cancelar"
                        cor="#0946B8"
                        valor={values}
                        onClick={() => {
                            setValues({});
                            setValuesSelect({});
                            removerErrosVazios({});
                            setTelaCadastro(false);
                            setEditando(false);
                            setTabelaRedux({});
                        }}
                    />
                )}
            </div>
        </MotionContainer>
    )
};

export default VeiculoCadastro;